(function () {
  var root = document.querySelector(".mq-accueil");
  if (!root) return;

  var hdr = root.querySelector("[data-mq-acc-header]");
  var burger = root.querySelector("[data-mq-acc-burger]");
  if (hdr && burger) {
    burger.addEventListener("click", function () {
      var open = hdr.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    hdr.querySelectorAll(".mq-acc-links a").forEach(function (a) {
      a.addEventListener("click", function () {
        hdr.classList.remove("is-open");
        burger.setAttribute("aria-expanded", "false");
      });
    });
  }

  var grid = root.querySelector("[data-mq-acc-grid]");
  var tabs = root.querySelector("[data-mq-acc-tabs]");
  if (grid && tabs) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-need]"));
    var needs = [];
    cards.forEach(function (c) {
      var n = c.getAttribute("data-need");
      if (n && needs.indexOf(n) === -1) needs.push(n);
    });
    needs.sort(function (a, b) {
      return a.localeCompare(b, "fr");
    });

    function setFilter(label) {
      tabs.querySelectorAll(".mq-acc-tab").forEach(function (t) {
        t.setAttribute("aria-pressed", t.getAttribute("data-filter") === label ? "true" : "false");
      });
      cards.forEach(function (c) {
        var n = c.getAttribute("data-need");
        c.hidden = label !== "Tout" && n !== label;
      });
    }

    ["Tout"].concat(needs).forEach(function (label, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "mq-acc-tab";
      b.textContent = label;
      b.setAttribute("data-filter", label);
      b.setAttribute("aria-pressed", i === 0 ? "true" : "false");
      b.addEventListener("click", function () {
        setFilter(label);
      });
      tabs.appendChild(b);
    });
  }
})();
